import { useCallback, useState } from "react";

function usePopperState(): [HTMLElement | null, (event: any) => void, boolean] {
  const [anchorEl, setAnchorEl] = useState(null);
  const toggleAnchorEl = useCallback((event) => {
    setAnchorEl((prev) =>
      !event || prev === event.currentTarget ? null : event.currentTarget
    );
  }, []);

  return [anchorEl, toggleAnchorEl, Boolean(anchorEl)];
}
export default usePopperState;
